/**
 * Stripe/checkout cache helpers.
 *
 * In this app, we persist temporary embedded-checkout details in localStorage
 * to survive refreshes (see `anonTempPurchase`). After a successful payment we
 * want to clean these values so future sessions start fresh.
 */

const STRIPE_CACHE_KEYS = [
  // Used to hydrate embedded-checkout on refresh.
  'anonTempPurchase',
];

/**
 * Clears Stripe-related client-side cache.
 *
 * Safe to call multiple times.
 *
 * @returns {{ cleared: string[] }}
 */
export function clearStripeCache() {
  const cleared = [];

  for (const key of STRIPE_CACHE_KEYS) {
    try {
      if (localStorage.getItem(key) != null) {
        localStorage.removeItem(key);
        cleared.push(key);
      }
    } catch {
      // ignore storage access errors (private mode, blocked cookies, etc.)
    }
  }

  return { cleared };
}
